import { cn } from '@/shared/lib/utils';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import * as React from 'react';

/**
 * 우측 드로어(M-12, 데스크톱 640) · 하단 시트(M-11 모바일 필터) · 모바일 GNB 메뉴.
 * Radix Dialog 기반이라 포커스 가두기 · ESC · body 스크롤 잠금을 기본 제공한다.
 */
const Sheet = DialogPrimitive.Root;
const SheetTrigger = DialogPrimitive.Trigger;
const SheetClose = DialogPrimitive.Close;
const SheetTitle = DialogPrimitive.Title;
const SheetDescription = DialogPrimitive.Description;

type SheetSide = 'right' | 'bottom' | 'left';

const sideClassName: Record<SheetSide, string> = {
  right: 'inset-y-0 right-0 h-full w-full lg:w-[640px]',
  bottom: 'inset-x-0 bottom-0 max-h-[85vh] w-full rounded-t-card',
  left: 'inset-y-0 left-0 h-full w-[280px]',
};

interface SheetContentProps extends React.ComponentPropsWithoutRef<
  typeof DialogPrimitive.Content
> {
  side?: SheetSide;
  /** 드로어 딤은 28%, 그 외 45% */
  overlay?: 'drawer' | 'popup';
}

const SheetContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  SheetContentProps
>(({ side = 'right', overlay = 'drawer', className, ...props }, ref) => (
  <DialogPrimitive.Portal>
    <DialogPrimitive.Overlay
      className={cn(
        'fixed inset-0 z-50',
        overlay === 'drawer' ? 'bg-dim-drawer' : 'bg-dim',
      )}
    />
    <DialogPrimitive.Content
      ref={ref}
      className={cn(
        'fixed z-50 flex flex-col overflow-hidden bg-surface outline-none',
        sideClassName[side],
        className,
      )}
      {...props}
    />
  </DialogPrimitive.Portal>
));
SheetContent.displayName = 'SheetContent';

export {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetTitle,
  SheetTrigger,
};
